(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-locations"] && !Shopify.designMode) return;
  try {
    
  function initLocationSliders() {
    const sections = document.querySelectorAll('.our-locations-section');
    
    sections.forEach(section => {
      const slider = section.querySelector('.locations-slider');
      const controlsContainer = section.querySelector('.locations-controls');
      const prevBtn = section.querySelector('.prev-arrow');
      const nextBtn = section.querySelector('.next-arrow');
      
      if (!slider || !controlsContainer || !prevBtn || !nextBtn) return;
      
      // Determine if scroll controls are needed
      const checkScrollable = () => {
        // Allow a 2px margin of error for rounding
        if (slider.scrollWidth > slider.clientWidth + 2) {
          controlsContainer.style.display = 'flex';
          updateButtons();
        } else {
          controlsContainer.style.display = 'none';
        }
      };

      const updateButtons = () => {
        if (slider.scrollLeft <= 5) {
          prevBtn.classList.add('disabled');
        } else {
          prevBtn.classList.remove('disabled');
        }
        
        if (Math.ceil(slider.scrollLeft + slider.clientWidth) >= slider.scrollWidth - 5) {
          nextBtn.classList.add('disabled');
        } else {
          nextBtn.classList.remove('disabled');
        }
      };

      // Handle arrow clicks
      const getScrollAmount = () => {
        const firstItem = slider.querySelector('.location-item');
        return firstItem ? firstItem.offsetWidth + 20 : 300;
      };
      
      prevBtn.addEventListener('click', () => {
        if (!prevBtn.classList.contains('disabled')) {
          slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });

      nextBtn.addEventListener('click', () => {
        if (!nextBtn.classList.contains('disabled')) {
          slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });

      slider.addEventListener('scroll', () => {
        updateButtons();
      }, { passive: true });

      window.addEventListener('resize', checkScrollable);
      
      // Timeout to ensure layout styles are properly applied before checking
      setTimeout(checkScrollable, 200);
      
      // Additional check for images loading altering width
      const images = slider.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('load', checkScrollable);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initLocationSliders);
  document.addEventListener('shopify:section:load', initLocationSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-products"] && !Shopify.designMode) return;
  try {
    
  function initStickyScrollCarousel() {
    const sections = document.querySelectorAll('.our-products-section');
    
    sections.forEach(section => {
      const slider = section.querySelector('.our-products-slider');
      const stickyWrapper = section.querySelector('.our-products-sticky-wrapper');
      const prevBtn = section.querySelector('.prev-arrow');
      const nextBtn = section.querySelector('.next-arrow');
      
      if (!slider || !stickyWrapper) return;

      const speedFactor = 1.2; // 1.2px vertical scroll per 1px horizontal scroll

      let currentScrollLeft = 0;
      let targetScrollLeft = 0;
      let isAnimating = false;
      let animationFrameId = null;

      function smoothAnimate() {
        const diff = targetScrollLeft - currentScrollLeft;
        if (Math.abs(diff) > 0.5) {
          currentScrollLeft += diff * 0.08; // 0.08 is the easing factor (smaller = smoother, larger = faster)
          slider.scrollLeft = currentScrollLeft;
          animationFrameId = requestAnimationFrame(smoothAnimate);
        } else {
          currentScrollLeft = targetScrollLeft;
          slider.scrollLeft = currentScrollLeft;
          isAnimating = false;
          animationFrameId = null;
        }
      }

      function updateDimensionsAndScroll() {
        if (window.innerWidth < 750) {
          if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
            isAnimating = false;
          }
          section.style.height = 'auto';
          slider.style.scrollBehavior = 'smooth';
          return;
        }

        slider.style.scrollBehavior = 'auto'; // Disable smooth horizontal scrolling during page scroll to prevent lag

        const scrollWidth = slider.scrollWidth;
        const clientWidth = slider.clientWidth;
        const horizontalScrollRange = scrollWidth - clientWidth;

        if (horizontalScrollRange <= 0) {
          section.style.height = 'auto';
          return;
        }

        const verticalScrollRange = horizontalScrollRange * speedFactor;
        const stickyWrapperHeight = stickyWrapper.offsetHeight;
        const trackHeight = stickyWrapperHeight + verticalScrollRange;

        // Set the height of the outer section track
        section.style.height = `${trackHeight}px`;

        // Get the active sticky top offset from CSS
        const stickyTop = parseFloat(window.getComputedStyle(stickyWrapper).top) || 0;

        const rect = section.getBoundingClientRect();
        const scrolledDistance = stickyTop - rect.top;
        const maxScrollDistance = trackHeight - stickyWrapperHeight;

        let progress = scrolledDistance / maxScrollDistance;
        progress = Math.max(0, Math.min(1, progress));

        targetScrollLeft = progress * horizontalScrollRange;

        // Start the animation loop if it's not already running
        if (!isAnimating) {
          isAnimating = true;
          currentScrollLeft = slider.scrollLeft;
          smoothAnimate();
        }

        // Update arrow button disabled states
        if (prevBtn && nextBtn) {
          if (targetScrollLeft <= 5) {
            prevBtn.classList.add('disabled');
          } else {
            prevBtn.classList.remove('disabled');
          }

          if (Math.ceil(targetScrollLeft + slider.clientWidth) >= slider.scrollWidth - 5) {
            nextBtn.classList.add('disabled');
          } else {
            nextBtn.classList.remove('disabled');
          }
        }
      }

      // Add scroll and resize listeners
      window.addEventListener('scroll', updateDimensionsAndScroll, { passive: true });
      window.addEventListener('resize', updateDimensionsAndScroll);
      
      // Update arrows click handlers to scroll the page vertically
      if (prevBtn && nextBtn) {
        const getScrollAmount = () => {
          const firstItem = slider.querySelector('.our-product-card');
          return firstItem ? firstItem.offsetWidth + 25 : 305;
        };

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (window.innerWidth >= 750) {
            const verticalDelta = getScrollAmount() * speedFactor;
            window.scrollBy({ top: -verticalDelta, behavior: 'smooth' });
          } else {
            slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
          }
        });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (window.innerWidth >= 750) {
            const verticalDelta = getScrollAmount() * speedFactor;
            window.scrollBy({ top: verticalDelta, behavior: 'smooth' });
          } else {
            slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          }
        });
      }

      // Initial execution
      setTimeout(updateDimensionsAndScroll, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', initStickyScrollCarousel);
  document.addEventListener('shopify:section:load', initStickyScrollCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  class VideoSlider {
    constructor(container) {
      this.container = container;
      this.slidesContainer = container.querySelector('.video-slides');
      this.slides = container.querySelectorAll('.video-slide');
      this.dots = container.querySelectorAll('.slider-dot');
      this.prevBtn = container.querySelector('.prev-btn');
      this.nextBtn = container.querySelector('.next-btn');
      
      this.currentIndex = 0;
      this.slideWidth = this.slides[0]?.offsetWidth || 0;
      
      this.init();
    }
    
    init() {
      if (!this.slides.length) return;
      
      // Update slide width on resize
      window.addEventListener('resize', () => {
        this.slideWidth = this.slides[0].offsetWidth;
      });

      // Navigation buttons
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
        this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
      }

      // Dots navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Scroll event to update dots
      this.slidesContainer.addEventListener('scroll', () => {
        // Debounce to improve performance or just calculate roughly
        const scrollPos = this.slidesContainer.scrollLeft;
        this.currentIndex = Math.round(scrollPos / this.slideWidth);
        this.updateDots();
      }, { passive: true });
    }

    goToSlide(index) {
      if (index < 0) {
        index = this.slides.length - 1; // Loop back to end
      } else if (index >= this.slides.length) {
        index = 0; // Loop to start
      }
      
      this.currentIndex = index;
      this.slidesContainer.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth'
      });
      
      this.updateDots();
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }

  // Initialize on load and Shopify theme editor events
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.video-slider-section').forEach(section => {
      new VideoSlider(section);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('video-slider-section')) {
      new VideoSlider(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
